import { render, staticRenderFns } from "./PageGetStarted.vue?vue&type=template&id=265bb520"
import script from "./PageGetStarted.vue?vue&type=script&lang=js"
export * from "./PageGetStarted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports